// {event: 'data.submit', hitScope: { formData: { ... } } }
// {event: 'data.invalid', hitScope: { formData: { ... }, formError: 'there was an error' } }

export const formTrackingEventHitscope = (element, data, error) => {
  let hitscope = {
    form_name:
      typeof element !== 'string'
        ? element?.getAttribute('data-name')
        : element,
    form_data: data,
  }
  if (error) {
    hitscope = { ...hitscope, form_error: error?.errors || error }
  }
  return hitscope
}

export const pageViewEventPageScope = data => {
  let pageScope = {
    url: data?.url,
    template: data?.template,
    website_version: data?.website_version,
    title: data?.title,
  }
  return pageScope
}
export const pageViewEventUserScope = data => {
  let userScope = {
    clinic: data?.clinic,
    has_credit: data?.has_credit,
    user_first_name: data?.first_name,
    user_last_name: data?.last_name,
    user_email: data?.user_email,
    user_phone_number: data?.user_phone_number,
    user_id: data?.user_id,
    gender: data?.gender,
    age: data?.age,
    is_hmo: data?.is_hmo,
  }
  return userScope
}

export const fortmatBotAnalyticsData = data => {
  let analyticsData = {
    question_text: data?.question_text,
    answer_text: data?.answer_text,
    // protocol_id: data?.protocol_id
  }
  if (data?.question_id) {
    analyticsData = { ...analyticsData, question_id: data?.question_id }
  }
  if (data?.answer_id) {
    analyticsData = { ...analyticsData, answer_id: data?.answer_id }
  }
  return analyticsData
}

export const formatClientSideError = error => {
  let errorFields = []
  Object.keys(error).forEach(item => {
    errorFields.push({
      name: item,
      errors: error[item],
      warnings: [],
    })
  })
  return {
    errorFields,
  }
}

export const customClickTracking = (event, hitScope) => {
  return {
    element_name: event,
    ...hitScope,
  }
}

export const eliminateNewLineCharFromString = str => {
  return str.replace('\n', ' ')
}
